module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<!-- build-targets/portal/packages/core-app/src/templates/appProgressView.html -->\n<div class="container">\n	<div class="container-fluid">\n		<h2 class="title"><span class="text">'+
((__t=( headerTitle ))==null?'':__t)+
'</span></h2>\n		<div id="app-progress-view-loader" class="pseudo-progress nx-autotemplate" data-nx-template="pseudo-progress"></div>\n		<p data-nx-control="message">'+
((__t=( message ))==null?'':__t)+
'</p>\n	</div>\n</div>';
}
return __p;
};
